import { createApi } from "@reduxjs/toolkit/query/react";
import { eox7ApiUrl } from "src/env";
import { makeResilientBaseQuery } from "src/common/redux/api/baseQuery";

/** The eox7 gateway (Exopen for Excel); accepts the portal's own Auth0 token. */
export const emptyEox7Api = createApi({
	reducerPath: "eox7Api",
	baseQuery: makeResilientBaseQuery({
		baseUrl: eox7ApiUrl,
	}),
	tagTypes: ["ExcelReports"],
	endpoints: () => ({}),
});
